<template>
  <v-container fluid v-if="this.$store.state.started">
    <v-layout column>
      <v-flex>
        <v-card :color="player.color">
          <v-card-title>
            <h1>{{player.name}}</h1>
          </v-card-title>
          <v-layout row wrap>
            <v-flex xs12 class="ma-1">
              <v-expansion-panel>
                <v-expansion-panel-content>
                  <div slot="header" :style="{color: player.color}">
                    <h1>Locations</h1>
                  </div>
                  <v-layout row wrap justify-space-between>
                    <v-flex xs12 sm12 md3 lg3 xl3 class="mb-4">
                      <v-slider
                        type="number"
                        label="Outposts"
                        v-model="player.locations.outposts"
                        step="1"
                        max="10"
                        ticks
                        thumb-label="always"
                      ></v-slider>
                    </v-flex>
                    <v-flex xs12 sm12 md3 lg3 xl3 class="mb-4">
                      <v-slider
                        type="number"
                        label="Farms"
                        v-model="player.locations.farms"
                        step="1"
                        max="10"
                        ticks
                        thumb-label="always"
                      ></v-slider>
                    </v-flex>
                    <v-flex xs12 sm12 md3 lg3 xl3 class="mb-4">
                      <v-slider
                        type="number"
                        label="Towns"
                        v-model="player.locations.towns"
                        step="1"
                        max="10"
                        ticks
                        thumb-label="always"
                      ></v-slider>
                    </v-flex>
                  </v-layout>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-flex>
            <v-flex xs12 class="ma-1">
              <v-expansion-panel>
                <v-expansion-panel-content>
                  <div slot="header" :style="{color: player.color}">
                    <h1>Pawns</h1>
                  </div>
                  <v-layout row wrap justify-space-between>
                    <v-flex xs12 sm12 md2 lg2 xl2 class="mb-4">
                      <v-slider
                        type="number"
                        label="Farmer"
                        v-model="player.pawns.farmer"
                        step="1"
                        max="3"
                        ticks
                        thumb-label="always"
                      ></v-slider>
                    </v-flex>
                    <v-flex xs12 sm12 md2 lg2 xl2 class="mb-4">
                      <v-slider
                        type="number"
                        label="Merchant"
                        v-model="player.pawns.merchant"
                        step="1"
                        max="3"
                        ticks
                        thumb-label="always"
                      ></v-slider>
                    </v-flex>
                    <v-flex xs12 sm12 md2 lg2 xl2 class="mb-4">
                      <v-slider
                        type="number"
                        label="Alchemist"
                        v-model="player.pawns.alchemist"
                        step="1"
                        max="3"
                        ticks
                        thumb-label="always"
                      ></v-slider>
                    </v-flex>
                    <v-flex xs12 sm12 md2 lg2 xl2 class="mb-4">
                      <v-slider
                        type="number"
                        label="Knight"
                        v-model="player.pawns.knight"
                        step="1"
                        max="3"
                        ticks
                        thumb-label="always"
                      ></v-slider>
                    </v-flex>
                    <v-flex xs12 sm12 md2 lg2 xl2 class="mb-4">
                      <v-slider
                        type="number"
                        label="Noble"
                        v-model="player.pawns.noble"
                        step="1"
                        max="3"
                        ticks
                        thumb-label="always"
                      ></v-slider>
                    </v-flex>
                    <v-flex xs12 sm12 md2 lg2 xl2 class="mb-4">
                      <v-slider
                        type="number"
                        label="Monk"
                        v-model="player.pawns.monk"
                        step="1"
                        max="3"
                        ticks
                        thumb-label="always"
                      ></v-slider>
                    </v-flex>
                  </v-layout>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-flex>
            <v-flex xs12 class="ma-1">
              <v-expansion-panel>
                <v-expansion-panel-content>
                  <div slot="header" :style="{color: player.color}">
                    <h1>Feudums</h1>
                  </div>
                  <v-layout row wrap justify-space-between>
                    <v-flex xs12 sm12 md2 lg2 xl2 class="mb-4">
                      <v-slider
                        type="number"
                        label="Farmer"
                        v-model="player.locations.feudums.farm"
                        thumb-label="always"
                        step="1"
                        ticks
                        max="2"
                      ></v-slider>
                    </v-flex>
                    <v-flex xs12 sm12 md2 lg2 xl2 class="mb-4">
                      <v-slider
                        type="number"
                        label="Merchant"
                        v-model="player.locations.feudums.merchant"
                        thumb-label="always"
                        step="1"
                        ticks
                        max="2"
                      ></v-slider>
                    </v-flex>
                    <v-flex xs12 sm12 md2 lg2 xl2 class="mb-4">
                      <v-slider
                        type="number"
                        label="Alchemist"
                        v-model="player.locations.feudums.alchemist"
                        thumb-label="always"
                        step="1"
                        ticks
                        max="2"
                      ></v-slider>
                    </v-flex>
                    <v-flex xs12 sm12 md2 lg2 xl2 class="mb-4">
                      <v-slider
                        type="number"
                        label="Knight"
                        v-model="player.locations.feudums.knight"
                        thumb-label="always"
                        step="1"
                        ticks
                        max="2"
                      ></v-slider>
                    </v-flex>
                    <v-flex xs12 sm12 md2 lg2 xl2 class="mb-4">
                      <v-slider
                        type="number"
                        label="Noble"
                        v-model="player.locations.feudums.noble"
                        thumb-label="always"
                        step="1"
                        ticks
                        max="2"
                      ></v-slider>
                    </v-flex>
                    <v-flex xs12 sm12 md2 lg2 xl2 class="mb-4">
                      <v-slider
                        type="number"
                        label="Monk"
                        v-model="player.locations.feudums.monk"
                        thumb-label="always"
                        step="1"
                        ticks
                        max="2"
                      ></v-slider>
                    </v-flex>
                  </v-layout>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "GuildCard",
  props: {
    player: Object
  }
};
</script>
